// src/api/subscriptionApi.js
import { api } from "./client";

export const subscriptionApi = {
  // Ungated beyond authentication (see
  // presentation/shared/subscription/subscription_controller.py::my_modules's
  // own docstring) — any org member can ask "which modules is this account
  // subscribed to" for their own UI gating, without holding
  // subscriptions:read. Returns only {name, active, always_included} —
  // never tier/expiry/billing detail.
  myModules: (accountId) =>
    api.get("/subscriptions/my-modules", { params: { account_id: accountId } }),

  // Admin surface (subscriptions:read / subscriptions:manage) — full module
  // list + activate/deactivate, for the Admin > Subscriptions tab.
  listModules: (accountId) => api.get(`/subscriptions/accounts/${accountId}/modules`),
  activateModule: (accountId, moduleName, { tier, expiresAt } = {}) =>
    api.post(`/subscriptions/accounts/${accountId}/modules/${moduleName}/activate`, {
      tier,
      expires_at: expiresAt || null,
    }),
  deactivateModule: (accountId, moduleName) =>
    api.delete(`/subscriptions/accounts/${accountId}/modules/${moduleName}`),
  activateTier: (accountId, tier, { expiresAt } = {}) =>
    api.post(`/subscriptions/accounts/${accountId}/tiers/${tier}/activate`, {
      expires_at: expiresAt || null,
    }),
};
